/**
 * ExcelReportGenerator.js
 */
import { saveAs } from "file-saver";

const getFileNameFromDisposition = (disposition, fallback) => {
  if (!disposition) return fallback;
  const match = disposition.match(/filename="?([^"]+)"?/i);
  return match?.[1] || fallback;
};

const downloadBackendExcelReport = async ({
  API_BASE_URL,
  complaintIds,
  viewStatus,
  selectedReport,
  filters = {},
  excludeStatuses = [],
}) => {
  const response = await fetch(
    `${API_BASE_URL}/complaints/reports/excel`,
    {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...filters,
        complaintIds,
        viewStatus,
        selectedReport,
        excludeStatuses,
      }),
    }
  );

  if (!response.ok) {
    let message = `Failed to generate Excel report (${response.status})`;
    try {
      const text = await response.text();
      if (text) message = `${message}: ${text}`;
    } catch (_) {}
    throw new Error(message);
  }

  const blob = await response.blob();
  const reportDate = new Date().toLocaleDateString();
  const fallbackName = `${viewStatus || "All"}_Complaints_Report_${reportDate}.xlsx`;
  const fileName = getFileNameFromDisposition(
    response.headers.get("Content-Disposition"),
    fallbackName
  );
  saveAs(blob, fileName);
};

export const generateBackendExcelReport = async ({
  API_BASE_URL,
  viewStatus,
  selectedReport = "standard",
  filters = {},
  excludeStatuses = [],
}) => {
  try {
    await downloadBackendExcelReport({
      API_BASE_URL,
      viewStatus,
      selectedReport,
      filters,
      excludeStatuses,
    });
    alert(`${selectedReport.toUpperCase()} report generated successfully!`);
  } catch (error) {
    console.error("Error generating report:", error);
    alert(error.message || "An error occurred while generating the report. Please try again.");
  }
};

/**
 * Compatibility wrapper for existing report buttons that already have complaint rows.
 * The workbook is still generated on the backend; only selected IDs are sent here.
 */
export const generateExcelReport = async (
  filteredComplaints,
  viewStatus,
  API_BASE_URL,
  knownCities = [],
  selectedReport = "standard"
) => {
  try {
    if (!filteredComplaints || filteredComplaints.length === 0) {
      alert("No complaints found for the selected filters.");
      return;
    }

    await downloadBackendExcelReport({
      API_BASE_URL,
      complaintIds: filteredComplaints.map((complaint) => complaint.id).filter(Boolean),
      viewStatus,
      selectedReport,
    });
    alert(`${selectedReport.toUpperCase()} report generated successfully!`);
  } catch (error) {
    console.error("Error generating report:", error);
    alert(error.message || "An error occurred while generating the report. Please try again.");
  }
};
